import {
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const changeUserPasswordReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_USER_PASSWORD:
      return { ...state, loading: true };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CHANGE_USER_PASSWORD_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default changeUserPasswordReducer;
